module.exports = __webpack_public_path__ + "img/wsp-blanco.a0d417dd.png";